import { render, staticRenderFns } from "./StatusSelector.vue?vue&type=template&id=1a81dcac&scoped=true"
import script from "./StatusSelector.vue?vue&type=script&lang=ts"
export * from "./StatusSelector.vue?vue&type=script&lang=ts"
import style0 from "./StatusSelector.vue?vue&type=style&index=0&id=1a81dcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a81dcac",
  null
  
)

export default component.exports